import type { AddressValidationState } from "@/types";

/** True when a physical address is present but geocoding validation has not succeeded. */
export function isAddressValidationBlocking(
  hasPhysicalAddress: boolean,
  state: AddressValidationState,
): boolean {
  if (!hasPhysicalAddress) return false;
  return state.status !== "valid";
}
